<template>
    <div class="wrapper ">
        <Sidebar />
        <div class="main-panel" id="main-panel">
            <Header />
            <div class="panel-header panel-header-sm">
                <canvas id="bigDashboardChart"></canvas>
            </div>
            <div class="content">
                <Loading v-if="loading == true" />
                <div class="row">
                    <div class="card">
                        <div class="card-header">
                            <h5 class="title">User Profile</h5>
                        </div>
                        <div class="card-body">
                            <Alert v-if="errorMessage.length > 0" :message="errorMessage" :error="true"/>
                            <Alert v-if="successMessage.length > 0" :message="successMessage" :error="false"/>
                            <div v-if="paymentIssue" class="row pt-2" style="color: white; background-color: red;">
                                <div class="col-12">
                                    <h6><b>There was an issue with your payment. Please update your payment preferences</b></h6>
                                </div>
                            </div>
                            <div class="row mb-3 ml-2">
                                <div v-if="userInfo.profile_pic" class="col-6">
                                    <img class="profile-pic" :src="userInfo.profile_pic" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 pr-1">
                                    <div class="form-group">
                                        <label>Full Name</label>
                                        <input v-model="userInfo.name" type="text" class="form-control" placeholder="Full Name">
                                    </div>
                                </div>
                                <div class="col-md-6 pl-1">
                                    <div class="form-group">
                                        <label>Display Name</label>
                                        <input v-model="userInfo.display_name" type="text" class="form-control" placeholder="Display Name">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4 pr-1">
                                    <div class="form-group">
                                        <label>Email</label>
                                        <input disabled v-model="userInfo.email" type="text" class="form-control" placeholder="Email">
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>Phone Number</label>
                                        <input v-model="userInfo.phone_number" type="text" class="form-control" placeholder="Phone Number">
                                    </div>
                                </div>
                                <div class="col-md-4 pl-1">
                                    <div class="form-group">
                                        <label>Job Title</label>
                                        <input v-model="userInfo.job_title" type="text" class="form-control" placeholder="Job Title">
                                    </div>
                                </div>
                            </div>

                             <div class="row mt-4">
                                <div class="col-md-6 pr-1">
                                    <div class="form-group">
                                        <label>New Password</label>
                                        <input v-model="newPassword" type="text" class="form-control" placeholder="New Password" value="Mythical">
                                    </div>
                                </div>
                                <div class="col-md-6 pl-1">
                                    <div class="form-group">
                                        <label>Verify Password</label>
                                        <input v-model="newPasswordVerify" type="text" class="form-control" placeholder="Verify Password" value="Developer">
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-5">
                                <div class="col">
                                    <Dropzone name="dropzone" id="dropzone" ref="imageDropzone" 
                                        :options="imageDropzoneOptions" 
                                        :useCustomSlot=true
                                        v-on:vdropzone-sending="appendFileName"
                                        @vdropzone-file-added="fileInDropzone=true"
                                        @vdropzone-removed-file="fileInDropzone=false">
                                        <div class="dropzone-custom-content">
                                            <h5 class="dropzone-custom-title">Click here or drag and drop an image</h5>
                                            <div class="subtitle">accepted file types: png jpg jpeg</div>
                                        </div>
                                    </Dropzone>
                                    <button v-if="fileInDropzone" class="btn btn-outline-danger ml-4" @click="removeImage">Clear Dropzone</button>
                                </div>
                            </div>
                                
                            <div v-if="isSuperAdmin == false">
                                <div class="row">
                                    <div class="col-3">
                                        <button v-if="showPaymentMethodButton == true && isPlatinum === false" class="btn btn-primary" @click="showPaymentMethod()">Payment Method</button>
                                    </div>
                                </div>
                                <div class="row mt-4">
                                    <div class="col-4">
                                        <label>Current Subscription Plan:</label>
                                    </div>
                                </div>

                                <div class="row mt-0 ml-4">
                                    <div class="col-4">
                                        <i>{{ currentPlanTitle }}</i>
                                    </div>
                                </div>
                                
                                <div v-if="isPlatinum === false">
                                    <div class="row mt-4">
                                        <div class="col-4">
                                            <label>Pick a New Plan</label>
                                        </div>
                                    </div>

                                    <div class="row mt-1">
                                        <div class="col-lg-4">
                                            <span class="ml-2">Monthly Plans</span>
                                            <select class="form-control" v-model="selectedPlan">
                                                <option disabled selected>Pick One</option>
                                                <option v-for="plan in activePlans['1']" :key="plan.id" :value="plan">{{ plan.plan_data.nickname }}</option>
                                            </select>
                                        </div>
                                            <div class="col-lg-4">
                                            <span class="ml-2">Quarterly Plans</span>
                                            <select class="form-control" v-model="selectedPlan">
                                                <option disabled selected>Pick One</option>
                                                <option v-for="plan in activePlans['3']" :key="plan.id" :value="plan">{{ plan.plan_data.nickname }}</option>
                                            </select>
                                        </div>
                                            <div class="col-lg-4">
                                            <span class="ml-2">Annual Plans</span>
                                            <select class="form-control" v-model="selectedPlan">
                                                <option disabled selected>Pick One</option>
                                                <option v-for="plan in activePlans['12']" :key="plan.id" :value="plan">{{ plan.plan_data.nickname }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <div class="row mt-5">
                                        <div class="col-12">
                                            <p style="font-size=20px;">If you would like to change your current subscription plan please contact ILYGuts at <b><a href="mailto:museo@ilyguts.com">museo@ilyguts.com</a></b></p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div :style="showPayment === true ? 'display: block;' : 'display: none;'">
                                <div class="row">
                                    <div class="col-lg-1"></div>
                                    <div class="col-lg-10">
                                        <h6 class="my-5">Billing Information</h6>
                                        <div ref="card">
                                            <!-- Stripe -->
                                        </div>
                                    </div>
                                    <div class="col-lg-1"></div>
                                </div>
                                <div class="row text-left mt-5">
                                    <div class="col-lg-1"></div>
                                    <div class="col-lg-10">
                                        <label>Name on Card</label>
                                        <input autocomplete="name" v-model = "billingInfo.name" class="form-control"/>
                                    </div>
                                    <div class="col-lg-1"></div>
                                </div>
                                <div class="row mt-4 text-left">
                                    <div class="col-lg-1"></div>
                                    <div class="col-lg-4">
                                        <label>Address</label>
                                        <input autocomplete="address-line1" v-model = "billingInfo.address1" class="form-control"/>
                                    </div>
                                    <div class="col-lg-3">
                                        <label>Address2</label>
                                        <input autocomplete="address-line2" v-model = "billingInfo.address2" class="form-control"/>
                                    </div>
                                    <div class="col-lg-3">
                                        <label>City</label>
                                        <input autocomplete="address-level2" v-model = "billingInfo.city" class="form-control"/>
                                    </div>
                                </div>
                                <div class="row mt-4 mb-3 text-left">
                                    <div class="col-lg-1"></div>
                                    <div class="col-lg-4">
                                        <label>State/Province</label>
                                        <input autocomplete="address-level1" v-model = "billingInfo.state" class="form-control"/>
                                    </div>
                                    <div class="col-lg-3">
                                        <label>Postal Code</label>
                                        <input autocomplete="postal-code" v-model = "billingInfo.postalCode" class="form-control"/>
                                    </div>
                                    <div class="col-lg-3">
                                        <label>Country</label>
                                        <select autocomplete="country-name" class="form-control custom-dropdown" v-model="billingInfo.country">
                                            <option disabled selected value="">Pick a Country</option>
                                            <option v-for="country in countries" :key="country.code" :value="country.code">{{ country.name }}</option>
                                        </select>
                                    </div>
                                    <div class="col-1"></div>
                                </div>
                                <div class="row mb-4">
                                    <div class="col-1"></div>
                                    <div class="col-10">
                                        <button v-if="currentPlanTitle != 'No Active Plan'" class="btn btn-primary" @click="submitPayment()">Submit</button>
                                    </div>
                                    <div class="col-1"></div>
                                </div>
                            </div>

                            <div class="row mt-5">
                                <div class="col-12">
                                    <button class="btn btn-primary" @click="updateUser()">Update Profile</button>
                                    <button v-if="isSuperAdmin == false && isPlatinum === false && currentPlanTitle != 'No Active Plan'" class="btn btn-danger float-right" @click="cancelSubscription()">Cancel Subscription</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Alert v-if="errorMessage.length > 0" :message="errorMessage" :error="true"/>
                <Alert v-if="successMessage.length > 0" :message="successMessage" :error="false"/>
            </div>
            <Footer />
        </div>
    </div>
</template>

<script>
    import Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';

    import JWT from '../services/jwt/JWT';
    import Users from '../controllers/user.controller';
    import Countries from '../controllers/countries.controller';
    import Subscriptions from '../controllers/subscriptions.controller';
    import Payments from '../controllers/payments.controller';

    import isSuperAdmin from '../services/jwt/isSuperAdmin';

    const imageUrl = process.env.VUE_APP_API_URL + '/image' || "http://localhost:3001/api/image";

    export default {
        name: "EditUserProfile",
        components: {
            Dropzone
        },
        data: function() {
            return {
                imageDropzoneOptions: {
                    url: (process.env.VUE_APP_API_URL + '/listing/upload/' + this.$route.params.listingID) || "http://localhost:3001/api/listing/upload/" + this.$route.params.listingID,
                    maxFilesize: 50, // Mb
                    maxFiles: 1,
                    autoProcessQueue: false,
                    acceptedFiles: '.png,.jpg,.jpeg',
                    header: {
                        'Authorization': 'Bearer ' + localStorage.getItem('access_token')
                    }
                },
                loading: false,
                fileInDropzone: false,
                showPayment: false,
                showPaymentMethodButton: true,
                spk: process.env.VUE_APP_STRIPE_PK,
                stripe: undefined,
                billingInfo: {},
                countries: [],
                errorMessage: '',
                successMessage: '',
                userInfo: {},
                newPassword: '',
                newPasswordVerify: '',
                isSuperAdmin: isSuperAdmin(localStorage.getItem('superAdmin')),
                activePlans: [],
                selectedPlan: null,
                currentPlanTitle: '',
                paymentIssue: !this.$route.params.notPaid ? false : true,
                isPlatinum: false
            }
        },
        beforeMount: async function() {
            this.loading = true;
            this.userInfo = await Users.getInfo();

            if (this.isSuperAdmin === false) {
                this.activePlans = await Payments.getActivePlans();
                this.currentPlanTitle = this.userInfo.subscription ? this.userInfo.subscription.subscription_status : "No Active Plan";
                
                if (this.userInfo.subscription && this.userInfo.subscription.planDetails.plan_type == null) {
                    this.isPlatinum = true;
                }
            }
            
            // Create the Stripe card and mount it
            this.stripe = Stripe(this.spk);
            this.card = this.stripe.elements().create('card', {
                style: {
                    base: {
                        fontWeight: 500,
                        fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
                        fontSize: '16px',
                        fontSmoothing: 'antialiased',
                    }
                }
            });
            this.card.mount(this.$refs.card);

            if (this.currentPlanTitle == 'No Active Plan') {
                this.showPaymentMethodButton = false;
                this.showPaymentMethod();
            }

            this.loading = false;
        },
        methods: {
            async updateUser() {
                this.successMessage = '';
                this.errorMessage = '';

                if (!this.userInfo.name || !this.userInfo.display_name || !this.userInfo.email || !this.userInfo.job_title || !this.userInfo.phone_number) {
                    this.errorMessage = "A mandatory field is missing";
                    return;
                }

                this.loading = true;

                // Check if there are any images that need to be uploaded
                if (this.$refs.imageDropzone.dropzone.files.length > 0) {
                    this.$refs.imageDropzone.processQueue();
                }

                // Check if the password needs to be updated
                if (this.errorMessage.length == 0 ) {
                    if (this.newPassword.length > 0) {
                        if (this.newPassword != this.newPasswordVerify) {
                            this.errorMessage = "New Passwords Not Matching";
                            this.loading = false;
                            return;
                        }

                        let resetSuccess = await Users.changePassword(this.newPassword);

                        if (resetSuccess === true) {
                            this.successMessage = "Password Reset Successfull";
                        } else if (resetSuccess.error) {
                            this.errorMessage = resetSuccess.error;
                            this.loading = false;
                            return;
                        } else {
                            this.errorMessage = "Something went wrong with your password reset";
                            this.loading = false;
                            return;
                        }
                    }

                    let updated = await Users.update(this.userInfo.firebase_id, this.userInfo.name, this.userInfo.display_name, this.userInfo.job_title, this.userInfo.phone_number, this.userInfo.email);

                    if (updated == false) {
                        this.errorMessage = "Error while updating profile";
                    } else if (updated.error) {
                        this.errorMessage = updated.error;
                    } else {
                        if (this.selectedPlan !== null) {
                            let currentPlanPrice = 0;
                            let subscriptionID;

                            if (this.userInfo.subscription) {
                                currentPlanPrice = await Payments.getPlanPrice(this.userInfo.subscription.subscription_type);
                            }

                            let selectedPlanPrice = await Payments.getPlanPrice(this.selectedPlan.plan_id);
                            let upgrading = currentPlanPrice < selectedPlanPrice;

                            if (this.userInfo.subscription_id) {
                                subscriptionID = this.userInfo.subscription.subscription_id;
                                let updated = await Subscriptions.update(this.userInfo.subscription.subscription_id, this.selectedPlan.id, this.selectedPlan.plan_id, upgrading);
                            
                                if (updated == false) {
                                    this.errorMessage = "Error while changing plans";
                                    this.loading = false;
                                    return;
                                } else if (updated.error) {
                                    this.errorMessage = updated.error;
                                    this.loading = false;
                                    return;
                                }
                            } else {
                                let payment = await this.submitPayment(true);
                                subscriptionID = await Subscriptions.create(payment.paymentMethod.id, this.userInfo.email,  this.selectedPlan.plan_id, this.selectedPlan.id, this.userInfo.firebase_id);

                                if (subscriptionID == false) {
                                    this.errorMessage = "Error while changing plans";
                                    this.loading = false;
                                    return;
                                } else if (subscriptionID.error) {
                                    this.errorMessage = subscriptionID.error;
                                    this.loading = false;
                                    return;
                                }

                                location.replace('edit-user');
                            }
                        }

                        this.userInfo = await Users.getInfo();
                        this.currentPlanTitle = this.userInfo.subscription ? this.userInfo.subscription.subscription_status : "No Active Plan";

                        this.successMessage = "Profile Information updated successfully";
                    }
                }

                this.loading = false;
            },

             async appendFileName(file, xhr, formData) {
                file.upload.filename = Date.now() + file.upload.filename.slice(file.upload.filename.lastIndexOf('.'), file.upload.filename.length);
                let uploaded = await Users.uploadImage(file.upload.filename, file.dataURL);
                if (uploaded == false) {
                    this.errorMessage = "Something went wrong with uploading your image";
                } else {
                    this.successMessage = "Image uploaded successfully";
                    this.userInfo = await Users.getInfo();
                    this.$refs.imageDropzone.removeAllFiles(true);
                }
            },

            removeImage() {
                this.$refs.imageDropzone.removeAllFiles();
            },

            async showPaymentMethod() {
                if (this.showPayment == false) {
                    this.loading = true;
                    let allCountries = await Countries.getAll();
                    for (let country of allCountries) {
                        this.countries.push({
                            name: country.name,
                            code: country.country_code
                        });
                    }

                    this.showPayment = true;
                    this.loading = false;
                }
            },

            async submitPayment(newPayment = false) {
                this.errorMessage = "";
                this.successMessage = "";

                if (!this.billingInfo.address1 || !this.billingInfo.address1 || !this.billingInfo.city || !this.billingInfo.state || !this.billingInfo.postalCode || !this.billingInfo.country) {
                    this.errorMessage = "Please make sure all billing mandatory fields are filled";
                    return;
                }

                this.loading = true;

                let result = await this.stripe.createPaymentMethod({
                    type: 'card',
                    card: this.card,
                    billing_details: {
                        name: this.billingInfo.name,
                        address: {
                            line1: this.billingInfo.address1,
                            line2: this.billingInfo.address2,
                            city: this.billingInfo.city,
                            state: this.billingInfo.state,
                            postal_code: this.billingInfo.postalCode,
                            country: this.billingInfo.country
                        }
                    }
                });

                if (result.error) {
                    this.errorMessage = result.error.message;
                    return;
                }

                if (newPayment === true) {
                    return result;
                }

                let created = await Subscriptions.create(result.paymentMethod.id, this.userInfo.email, this.userInfo.subscription.plan_id, this.userInfo.subscription.planDetails.id, this.userInfo.firebase_id);

                if (created == false) {
                    this.errorMessage = "Something went wrong while creating your subscription";
                } else if (created.error) {
                    this.errorMessage = created.error;
                } else {
                    this.successMessage = "Payment info successfully updated";
                }

                this.loading = false;
            },

            async cancelSubscription() {
                this.errorMessage = "";
                this.successMessage = "";

                let deleted = await Subscriptions.cancel();
                
                if (deleted === false) {
                    this.errorMessage = "Something went wrong while cancelling your subscription";
                } else if (deleted.error) {
                    this.errorMessage = deleted.error;
                } else {
                    this.successMessage = "Unsubscribed successfully";
                    location.replace('edit-user/notPaid');
                }

            }

        }
    }
</script>